<template>
  <div class="login-page">
    <app-navbar-login></app-navbar-login>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image" data-color="green">
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <card type="login">
                <h3 slot="header" class="text-center">Reset Password?</h3>
                <p v-bind:class="{ websphereShow: isHidden }">
                  {{ submitResult }}
                </p>
                <fg-input name="email"
                  type="email"
                  v-model="model.email"
                  v-validate="modelValidations.email"
                  :error="getError('email')"
                  addon-left-icon="nc-icon nc-email-85" placeholder="Email...">
                </fg-input>
                
                <fg-input 
                  name="password"
                  type="password"
                  v-model="model.password" ref="password"
                  v-validate="modelValidations.password"
                  :error="getError('password')"
                  addon-left-icon="nc-icon nc-key-25" placeholder="Password...">
                </fg-input>

                <fg-input 
                  name="confirmPassword"
                  type="password"
                  v-model="model.confirmPassword" 
                  v-validate="modelValidations.confirmPassword"
                  :error="getError('confirmPassword')"
                  addon-left-icon="nc-icon nc-key-25" placeholder="Confirm Password...">
                </fg-input>
    

                <p-button slot="footer" type="success" round block class="mb-3" @click.prevent="validate">{{ buttonText }}</p-button>
              </card>
            </div>
          </div>
        </div>
        <app-footer-login></app-footer-login>
        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
  import {Card, Button} from 'src/components/UIComponents';
  import AppNavbarLogin from './Layout/AppNavbarLogin'
  import AppFooterLogin from './Layout/AppFooterLogin'
  export default {
    components: {
      Card,
      AppNavbarLogin,
      AppFooterLogin,
      [Button.name]: Button
    },
    data () {
      return {
        isHidden: true,
        buttonText: 'Reset Password',
        submitResult: '',
        model: {
          email: this.$route.query.email, 
          token: this.$route.query.token,
          password: '',
          confirmPassword: '',
        },
        modelValidations: {
          email: {
            required: true,
            email: true
          },
          password: {
            required: true
          },
          confirmPassword: {
            required: true,
            confirmed: 'password'
          },
        }
      }
    },
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          this.$emit('on-submit', this.registerForm, isValid)
          if(isValid){
            this.resetPassword()
          }
        })
      },
      resetPassword (){
        this.buttonText='Reseting Password ...'

        this.$http.post('/reset-password', {
          email: this.model.email,
          password: this.model.password,
          password_confirmation: this.model.confirmPassword,
          token: this.model.token
        })
        .then(response=>{
          this.buttonText = "Submit"
          
          if(response.data.message == "Your password has been reset!") {
            this.submitResult = 'Your password has been reset. You can now login with your new password.'
          } else {
            this.submitResult = "We could not reset your password."
          }
          this.isHidden = false

          this.model.email = ''
          this.model.password = ''
          this.model.confirmPassword = ''
          this.$nextTick(function () {
            this.$validator.reset()
          })
        })
        .catch(error =>{
          this.loginButtonText = "Submit"
          this.submitResult = "We could not reset your password"
        })
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>
.login-page .content .container { margin-top: 0px !important; margin-left: 0px;}
.ml-auto, .mx-auto { margin-left: 0px !important; }
.login-page #websphereCoded {margin-left: 40px !important;}
.login-page .h3, .login-page h3 {margin-bottom: 0px; line-height: normal }
.websphere-show  {display: none}
</style>
